module.exports = __webpack_public_path__ + "b67aa850e7ecf648911901d7a2be3548.svg";